import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { EAnswerType } from 'src/app/admin/reports/csat-builder/csat-builder.component';
import { ComponentContext } from 'src/app/modules/modal/modal.model';

@Component({
  selector: 'gcc-survey-positive-modal',
  templateUrl: './survey-negative-modal.component.html',
  styleUrls: ['./survey-negative-modal.component.scss'],
  standalone: false
})
export class SurveyNegativeModal implements ComponentContext<any>, OnInit {
  @Input() public id: number;
  @Input() public answerType: number;
  @Input() public questionTitle: string;
  @Input() public options: any[];
  @Input() public onAction: (value: any) => void;
  @Input() public onClose: () => void;

  public isOther: boolean = false;
  public isValid: boolean = false;
  private value = {
    surveyBuilderQuestionId: 1,
    isPositive: false,
    answerText: null,
    isCompleted: true,
    optionAnswers: []
  };

  public ETypes = EAnswerType;

  form = new FormGroup({
    other: new FormControl('')
  });

  ngOnInit(): void {
    this.value = {
      ...this.value,
      surveyBuilderQuestionId: this.id
    };
    if (this.answerType === this.ETypes.Single) {
    }
    this.form.valueChanges.subscribe(value => {
      this.value.answerText = value.other;
      this.isValid = this.isOther ? !!this.value.answerText : !!this.value.optionAnswers.length;
    });
  }

  public onCloseSurvey(): void {
    this.onAction({
      ...this.value,
      answerText: '',
      isCompleted: false
    });
    this.onClose();
  }

  public onSubmit(): void {
    this.onAction(this.value);
    this.onClose();
  }

  handelSurveyNegativeRadio(value): void {
    this.isOther = value.selected === -1;
    const optionAnswers = !this.isOther ? [{ surveyBuilderOptionId: value.selected }] : [];
    this.value = {
      ...this.value,
      answerText: this.isOther ? this.form.value.other : '',
      optionAnswers
    };
    this.isValid = this.isOther ? !!this.value.answerText : !!this.value.optionAnswers.length;
  }
  handelSurveyNegativeCheckbox(value): void {
    this.isOther = !!value.list.filter(item => item.id === -1 && item.checked).length;

    const optionAnswers = value.list
      .filter(item => item.id !== -1 && item.checked)
      .map(item => ({ surveyBuilderOptionId: item.id }));

    this.value = {
      ...this.value,
      answerText: this.isOther ? this.form.value.other : '',
      optionAnswers
    };

    this.isValid = this.isOther ? !!this.value.answerText : !!this.value.optionAnswers.length;
  }
}
